import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const getCurrentDogProfile = () => {
  const dogsProfile = useZustandStore.getState().dogsProfile
  const currentDogId = useZustandSessionStore.getState().currenDogId

  return dogsProfile && dogsProfile.length > 1
    ? dogsProfile.find((dog) => dog.id === currentDogId)
    : dogsProfile?.[0]
}
